import {
  DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_BEGIN,
  DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_SUCCESS,
  DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_FAILURE,
  DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function saveExternaldatabaseForDirectus(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_BEGIN,
    });
    const { projectId, projectVersion } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${projectVersion}/directus/save-externaldata`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
          console.log('res here DIRECTUS data', res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_FAILURE,
            data: { error: err },
          });
          const { response } = err;
          if (response.status === 400) {
            const { error } = response.data ? response.data : '';
            toast.error(`${error} !`);
          } else {
            console.log('error', err);
          }
          reject(err);
        },
      );
    });

    return promise;
  };
}
export function dismissSaveExternaldatabaseForDirectusError() {
  return {
    type: DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_BEGIN:
      return {
        ...state,
        saveExternaldatabaseForDirectusPending: true,
        saveExternaldatabaseForDirectusError: null,
      };

    case DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_SUCCESS:
      return {
        ...state,
        saveExternaldatabaseForDirectusPending: false,
        saveExternaldatabaseForDirectusError: null,
        externalDbUuid: action.data.uuid,
      };

    case DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_FAILURE:
      return {
        ...state,
        saveExternaldatabaseForDirectusPending: false,
        saveExternaldatabaseForDirectusError: action.data.error,
      };

    case DATA_CONNECTOR_SAVE_EXTERNALDATABASE_FOR_DIRECTUS_DISMISS_ERROR:
      return {
        ...state,
        saveExternaldatabaseForDirectusError: null,
      };

    default:
      return state;
  }
}
